import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import Fade from "react-reveal/Fade";
import ThemeToggle from "../Theme-Toggle/ThemeToggle";
import "./Navbar.scss";
import NavbarData from "data/navbar.json";

const Navbar = () => {
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 300);
    });
  });

  const navbarDataWithId = NavbarData.map((data, index) => ({
    id: index + 1,
    ...data,
  }));

  return (
    <Fade top>
      <nav
        className={`navbar navbar-expand-lg clean-navbar ${
          scroll ? "sticky" : ""
        }`}
      >
        <div className="container">
          <Link
            className="navbar-brand logo"
            to="about"
            offset={-100}
            spy={true}
            href="about"
          >
            Nandun Diaz
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto">
              {navbarDataWithId.map((element) => (
                <li key={element.id} className="nav-item">
                  <Link
                    key={element.id}
                    activeClass="active"
                    className="nav-link"
                    to={element.href}
                    offset={element.href === "about" ? -100 : -20}
                    spy={true}
                    href={element.href}
                  >
                    {element.label}
                  </Link>
                </li>
              ))}
              <li className="nav-item theme-toggle">
                <ThemeToggle />
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </Fade>
  );
};

export default Navbar;
